<template>
  <div>
    <page-blog :page.sync="page" :limit="limit" :total.sync="total" :data.sync="data" :count-langs.sync="countLangs">
      <template #category>
        <template v-if="project === 'rzaska'">
          <product-tiles class="is-hidden-desktop" />
        </template>
        <template v-if="project === 'schuette'">
          <category-tiles class="is-hidden-desktop" />
        </template>
      </template>
    </page-blog>
  </div>
</template>
<script>
import PageBlog from '~/marketplace-front-core/pages/cms/blog'
import CategoryTiles from '~/components/layout/CategoryTiles.vue'
import ProductTiles from '~/components/layout/ProductTiles.vue'
export default {
  name: 'PageCmsBlog',
  components: {
    PageBlog,
    CategoryTiles,
    ProductTiles
  },
  async asyncData ({ app, query, store }) {
    const page = parseInt(query.page) || 1
    const limit = 10

    const res = await app.$api.cms.list({
      page,
      limit,
      lang: store.state.i18n.locale
    }).catch(() => { return null })
    const data = res ? res.query : []
    const total = res ? res.count : 0
    const countLangs = res ? res.countLangs : null

    return { data, page, limit, total, countLangs }
  },
  head () {
    const page = this.page || 1
    const seoTitle = page > 1
      ? this.$t('project.seo.blogPage.title', { page })
      : this.$t('project.seo.blog.title')
    return {
      titleTemplate: () => seoTitle,
      meta: [
        { hid: 'description', name: 'description', content: this.$t('project.seo.blog.description') }
      ]
    }
  }
}
</script>
